import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setTheResignEditAction,
  SetTheResignRetrieveActions,
  resetExitFlowUpdate,
  setTablePositionPersist
} from "../../../Redux/Slice";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { data } from "jquery";
const Exitflowaaprove = (props) => {
  const { currentPage, setShow, show, EditId, selectVal, data , white_collar ,filter_list ,old_employee } = props;
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
   const TablePositionPersist = useSelector((state) => state.PreviousPagePosition.TablePositionPersist);
  const [descpErr, setdeserr] = useState("");
  const initialState = {
    emp_date: "",
    to_date: "",

    status: "",
    purpose: "",
    applied_date: "",
    user_id: "",
    user_uid: "",
    certificate_id: "",
    client_id: "",
    user_name: "",
    description: "",
  };
  const [Data, setDatas] = useState(initialState);
  const dispatch = useDispatch();
  const state = useSelector((state) => state);

  useEffect(() => {
    console.log(state.exit_flow_managemanets?.Exit_flow_managements_list, "34567890987654");
    if (state.exit_flow_managemanets?.Exit_flow_managements_list.id != undefined) {
      const dateString =
        state.exit_flow_managemanets?.Exit_flow_managements_list.applied_date;
      const dateObject = new Date(dateString);
      const hours = dateObject.getHours();
      const minutes = dateObject.getMinutes();
      const amOrPm = hours >= 12 ? "PM" : "AM";
      const twelveHourFormat = hours % 12 || 12;
      const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;

      setDatas({
        ...Data,
        user_uid: state.exit_flow_managemanets?.Exit_flow_managements_list.user_id?.user_uid,

        status: state.exit_flow_managemanets?.Exit_flow_managements_list.status,
        emp_date: state.exit_flow_managemanets?.Exit_flow_managements_list.emp_date,
        to_date: state.exit_flow_managemanets?.Exit_flow_managements_list.to_time,
        purpose: state.exit_flow_managemanets?.Exit_flow_managements_list.remarks,
        user_name:
          state.exit_flow_managemanets?.Exit_flow_managements_list.user_id.first_name,
        client_id:
          state.exit_flow_managemanets?.Exit_flow_managements_list.client_id != null ? state.exit_flow_managemanets?.Exit_flow_managements_list.client_id.client_name :" ",
        description:
          state.exit_flow_managemanets?.Exit_flow_managements_list.reason_for_decline,
      });
    }
  }, [state.exit_flow_managemanets?.Exit_flow_managements_list]);
  const HandleChanges = (e) => {
    setDatas({
      ...Data,
      status: e.target.value,
    });
  };
  const HandleDecriptions = (e) => {
    setDatas({
      ...Data,
      description: e.target.value,
    });
    setdeserr("");
  };

  const handleClose = () => {
    setShow(false);
  };
  const HandleClick = () => {

    
            const newEntry = { isApproved: true };
                    const result = { ...TablePositionPersist.ExitnewflowlistRequestedPagelist, ...newEntry };
                    dispatch(
                      setTablePositionPersist({
                        data: result,
                        pageName: "ExitnewflowlistRequestedPagelist",
                      })
                    ); 
    const payload = {
      status: Data.status.toLowerCase(),
      description:
      Data.status.toLowerCase() == "decline" ? Data.description : "",
     // description: Data.description,
      EditId: EditId,
      get_list_param : {
      search: "",
      page_size: 10,
      page: currentPage,
      status: selectVal,
    state:filter_list?.state,
    region:filter_list?.region,
    zone:filter_list?.zone,
    old_employee:old_employee
          }
    };
    dispatch(resetExitFlowUpdate(payload, props.setShow()));
  };
  const Options = [
    {
      id: 1,
      Status: "Approved",
    },
    {
      id: 2,
      Status: "Decline",
    },
    {
      id: 3,
      Status: "Pending",
    },
  ];
  return (
    <>
      <div className={`${stateDisplay ? " POPUP" : "outerPOPUP"}`}>
        <div className="col BodyContent LeaveEdits">
          <div className="card">
            <div className="card-body cards ">
              <div className="UserPoup">
                <div className="BeforForms">
                  <div className="Form">
                    <div className="ModalHeader">
                      <span>Exit</span>
                      <div
                        className="CloseIcon"
                        onClick={(e) => setShow(false)}
                      >
                        <CloseOutlinedIcon />
                      </div>
                    </div>
                    <div className="Modal-Body Modal-bodyUserCRUD">
                      <div className="row">
                        <div
                          className="col-sm-3  mt-3"
                          style={{ marginTop: "40px" }}
                        >
                          <label for="validationCustom01" class="form-label">
                            Name
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            autocomplete="off"
                            value={Data.user_name}
                            name="last_name"
                            readOnly
                          />
                        </div>

                        <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            Exit remarks
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="validationCustom01"
                            autocomplete="off"
                            name="first_name"
                            value={Data.purpose}
                            readOnly
                          />
                        </div>

                        <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            Client name
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            autocomplete="off"
                            value={Data.client_id}
                            name="last_name"
                            readOnly
                          />
                        </div>

                        <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            Employee Code
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="validationCustom01"
                            autocomplete="off"
                            name="name"
                            value={Data.user_uid}
                            readOnly
                          />
                        </div>

                        <div className="col-sm-3 mt-3">
                          <label for="validationCustom01" class="form-label">
                            Status
                          </label>
                          <select
                            class="form-select form-select-lg col-12"
                            aria-label=".form-select-lg example"
                            onChange={HandleChanges}
                            /// value={Data.status}
                          >
                            {Options.map((item) => (
                              <option
                                selected={
                                  Data.status.toLowerCase() ==
                                  item.Status.toLowerCase()
                                }
                                value={item.Status}
                              >
                                {item.Status}
                              </option>
                            ))}
                          </select>
                        </div>
                        {Data.status.toLowerCase() == "decline" ? (
                        <>
                          <div
                            className="col-sm-3 mt-3"
                            style={{ width: "700px" }}
                          >
                            <label for="validationCustom01" class="form-label">
                              Reason for decline
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              required
                              autocomplete="off"
                              name="description"
                              value={Data.description}
                              onChange={HandleDecriptions}
                            />
                            <p style={{ color: "red" }}>{descpErr}</p>
                          </div>
                        </>
                      ) : null}
                      </div>

                   
                    </div>

                    <div className="UserButtons">
                      <button
                        class="btn  SaveBtn"
                        type="submit"
                        onClick={(e) => {
                          HandleClick(e);
                        }}
                        disabled={
                          state.exit_flow_managemanets?.Exit_flow_managements_list.status ==
                          Data.status.toLowerCase()
                        }
                      >
                        Submit
                      </button>
                      <button
                        class="btn CancelBtn"
                        onClick={(e) => handleClose(e)}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Exitflowaaprove;
